import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../_services/dialog.service';
import { UPNService, UPNListView } from '../_services/upn.service';
import { UPN } from '../_models/UPN';
// import { Upn } from '../_models/Coupon';
import { ManagementComponentBase } from '../_shared/base.management.component';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../_services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { JWTTokenService } from '../_services/jwtToken.service';

@Component({
  selector: 'app-upn',
  templateUrl: '../_shared/base.management.component.html',
  styleUrls: ['../_shared/base.management.component.css'],
})

export class UpnComponent extends ManagementComponentBase<UPNListView, UPN> {
  public loading = false; // remember to set this to true once work begins on this page
  public upns: UPN[] = [];
  public displayUpn: UPN[] = [];

  public searchText: string;


  protected GetRouteName(): string {
    return 'upn';
  }

  constructor(
    public router: Router,
    public dialogService: DialogService,
    public viewRef: ViewContainerRef,
    private upnService: UPNService,
    protected httpClient: HttpClient,
    protected userService: UserService,
    spinner: NgxSpinnerService,
    jwtTokenService: JWTTokenService
  ) {
    super(upnService, router, dialogService, viewRef, httpClient, userService, spinner, jwtTokenService);
  }

  /*
  ngOnInit() {
    this.loadUPNs().subscribe();
  }
  */

  /*
  public deleteUPN(id: number) {
    this.dialogService.confirm('Confirm Delete', 'Are you sure you want to delete this UPN?', this.viewRef).then(result => {
      if (result) {
        this.loading = true;
        this.upnService
          .deleteUPN(id)
          .pipe(
            tap(
              () => {
                this.loading = false;
              },
              () => {
                this.loading = false;
                this.dialogService.alert('Error', 'Unable to delete UPN', this.viewRef);
              }
            )
          )
          .flatMap(() => this.loadUPNs())
          .subscribe();
      }
    });
  }
  */

  public editUPN(id: number) {
    this.router.navigate(['/portal/upn/', id]);
  }

  /*
  private loadUPNs(): Observable<any> {
    return this.upnService.listUPNs().pipe(
      tap(
        data => {
          this.upns = this.displayUpn = data;
          this.loading = false;
        },
        () => {
          this.dialogService.alert('Error', 'Unable to load UPNs', this.viewRef);
          this.loading = false;
        }
      )
    );
  }
  */

  public newUPN() {
    this.router.navigate(['/portal/upn/create']);
  }
}
